import { useEffect, useState } from 'react'
import { useLazyGetUserDetailsQuery } from 'util/rtk-api'

export const useStudentId = (): string => {
	const [ studentId, setStudentId ] = useState<string>('')
	const [ triggerGetUserDetails ] = useLazyGetUserDetailsQuery()

	useEffect(() => {
		const getStudentId = async () => {
			console.log('getting student id')
			try {
				const id = localStorage.getItem('studentId')
				if (id) {
					setStudentId(id)
				} else {
					// get the user id from the cognito id token
					const user = await triggerGetUserDetails().unwrap()
					if (user) {
						setStudentId(user.userId)
					}
				}
			} catch {}
		}
		getStudentId()
	}, [])

	return studentId
}
